import {FC, useCallback, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import moment from 'moment'
import {getAllUserDetails} from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {readNotification} from '../../../Redux/NotificationSlice/NotificationSlice'
import {
  useAffiliateResponseAccessMutation,
  useSubmitReferralCodeApprovalMutation,
  useUpdateAccountTypeChangeRequestMutation,
} from '../../../../services/cellcast.v2'
import {
  useAdminUpdateSalesTypeMutation,
  useLazyExportAllApprovalNotificationQuery,
  useLazyGetAllApprovalNotificationQuery,
} from '../../../../services/cellcast'
import {isAllowApproveMessage} from '../../../Utils/Constant/allowedAction'
import {capitalizeFirstLetter} from '../../../Utils/_helpers'
import {OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {ApprovedBussinessName, UpdateAssigneTo} from '../../../Redux/AdminPanel/AssignUserSlice'
import {FirstMessageApprovalResponse} from '../FirstMessageAprroval/FirstMessageApprovalSlice'
import {toast} from 'react-toastify'
import ReactPaginate from 'react-paginate'
import NodataYet from '../../../Components/NodataYet'
import {ENV} from '../../../Utils/_helpers/EnvHelper'
import {KTSVG} from '../../../../_metronic/helpers'

const ApprovalNotifications: FC = () => {
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const dispatch = useDispatch()
  const isAdmin = localStorage.getItem('isAdmin')
  const userData: any = useSelector(getAllUserDetails)

  const [fetchNotifications, {data: allNotifications}] = useLazyGetAllApprovalNotificationQuery()
  const [exportData, {isLoading: isExportLoading}] = useLazyExportAllApprovalNotificationQuery()

  const [page, setPage] = useState({
    page: 1,
    size: 10,
  })
  const [isRefresh, setIsRefresh] = useState(false)

  useEffect(() => {
    if (page.page || page.size) {
      fetchNotifications(page)
    }
  }, [page.page, page.size])

  useEffect(() => {
    if (page.page || page.size) {
      fetchNotifications(page)
    }
  }, [isRefresh])

  const notificationDot: any = {
    alert: 'danger',
    warn: 'warning',
    success: 'success',
  }

  const [updateAccountType, {isLoading: isLoadingUpdate}] =
    useUpdateAccountTypeChangeRequestMutation()
  const [handleSubmitReferralCode, handleSubmitRefferalCodeResponse] =
    useSubmitReferralCodeApprovalMutation()
  const [handleRequestAccess, {isLoading: handleRequestAccessLoading}] =
    useAffiliateResponseAccessMutation()
  const [updateSalesType] = useAdminUpdateSalesTypeMutation()

  const getMessageVerificationRequestTitle = (data: any) => {
    if (data && data?.notificationType == 'message_verification_request') {
      if (
        data.notificationDetails &&
        data.notificationDetails.messageMetadata &&
        data.notificationDetails.messageMetadata.isFraudApproval === true
      ) {
        return data.notificationDetails.messageMetadata.isFraudMessage
      } else {
        return data.notificationDetails?.message
      }
    }
    return data?.message
  }

  const getFontColor = (data: any) => {
    let color = ['approved', 'appproved'].includes(data?.status) ? 'success' : 'danger'

    if (data?.isApproveByOwner === false) {
      return 'danger'
    }

    if (data?.isMoreSla === true) {
      return 'danger'
    }

    return color
  }

  const handleExports = useCallback(() => {
    exportData(null)
      .then((res) => {
        if ('data' in res) {
          const resData = res.data?.data as any
          window.open(`${API_DOMAIN}${resData?.downloadurl}`, '_self')
        } else if ('error' in res) {
          toast.error(res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
  }, [API_DOMAIN])

  return (
    <div className={`sub-accountstable card`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>Approval Details</span>
          <span className='text-muted fw-light fs-7'>All approval notifications</span>
        </h3>
        <div className='d-flex justify-content-end'>
          <div className='ms-2'>
            <button
              data-testid='btnExportUsers'
              onClick={() => handleExports()}
              type='button'
              className='btn btn-light-primary me-3'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
              Export
            </button>
          </div>
        </div>
      </div>
      {allNotifications?.data?.items?.length > 0 ? (
        <div className='card-body py-3'>
          <div className='table-responsive'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-400 text-muted '>
                  <th className='p-0'>DESCRIPTION</th>
                  <th className='p-0 text-center'>TYPE</th>
                  <th className='p-0 text-center'>DATE & TIME</th>
                  <th className='p-0 text-center'>Account Owner</th>
                  <th className='p-0 text-center'>Approver</th>
                  <th className='p-0 text-center'>Date</th>
                  {isAdmin === 'true' ? (
                    <th className='p-0 ps-3 min-w-175px text-center '>ACTION</th>
                  ) : (
                    <th className='p-0 ps-3 min-w-175px text-center '>ACTION</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {allNotifications?.data?.items?.map((data: any, idx: number) => (
                  <>
                    <tr key={idx} className='border-dashed border-2 border-bottom'>
                      <td>{getMessageVerificationRequestTitle(data)}</td>
                      <td className='text-center'>
                        <a
                          className={`badge badge-light-${
                            notificationDot?.[data.color] === undefined
                              ? 'warning'
                              : notificationDot?.[data.color]
                          }`}
                        >
                          {data?.type}
                        </a>
                      </td>
                      <td className='text-center'>
                        {moment(data?.createdAt).format('DD/MM/YYYY')} at{' '}
                        {moment(data?.createdAt).format('LT')}
                      </td>
                      <td>
                        {data?.accountManager?.name && (
                          <span className='fw-bold fs-6 mb-2'>
                            {data?.accountManager?.name && data?.sales?.name && '-'}{' '}
                            {data?.accountManager?.name}
                          </span>
                        )}
                        {data?.sales?.name && (
                          <span className='fw-bold fs-6'>
                            {data?.accountManager?.name && data?.sales?.name && '-'}{' '}
                            {data?.sales?.name}
                          </span>
                        )}

                        {!data?.accountManagerData?.name && !data?.sales?.name ? '-' : ''}
                      </td>
                      <td className='text-center'>
                        {data?.responseBy?.name ? (
                          <span className='fw-bold fs-6 mb-2'>{data.responseBy?.name}</span>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td className='text-center'>
                        {data?.responseAt
                          ? ` ${moment(data?.responseAt).format('DD/MM/YYYY')} at ${moment(
                              data?.responseAt
                            ).format('LT')}`
                          : '-'}
                      </td>
                      {isAllowApproveMessage(userData?.role || 'superAdmin') ? (
                        <td className='text-center'>
                          <div className='row justify-content-center m-0 gap-2'>
                            {data?.notificationType == 'staff_assign_request' &&
                            (['approved', 'appproved'].includes(data?.status) ||
                              data?.status == 'rejected') ? (
                              <a className={`badge badge-light-${getFontColor(data)} w-auto`}>
                                {capitalizeFirstLetter(data?.status)}
                              </a>
                            ) : data?.notificationType === 'staff_assign_request' ? (
                              <>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Approve Staff</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      dispatch(
                                        UpdateAssigneTo({
                                          userId: data?.notificationDetails?.userId,
                                          salesId: data?.notificationDetails?.salesId,
                                          accountManagerId:
                                            data?.notificationDetails?.accountManagerId,
                                          status: 'approved',
                                          notificationId: data?._id,
                                        })
                                      ).then(() => {
                                        setIsRefresh(!isRefresh)
                                      })
                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-check fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Reject Staff</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      dispatch(
                                        UpdateAssigneTo({
                                          userId: data?.notificationDetails?.userId,
                                          salesId: data?.notificationDetails?.salesId,
                                          accountManagerId:
                                            data?.notificationDetails?.accountManagerId,
                                          status: 'rejected',
                                          notificationId: data?._id,
                                        })
                                      ).then(() => {
                                        setIsRefresh(!isRefresh)
                                      })
                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-x fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                              </>
                            ) : null}

                            {data?.notificationType == 'business_name_request' &&
                            (data?.status == 'appproved' || data?.status == 'rejected') ? (
                              <a className={`badge badge-light-${getFontColor(data)} w-auto`}>
                                {capitalizeFirstLetter(data?.status)}
                              </a>
                            ) : data?.notificationType === 'business_name_request' ? (
                              <>
                                {' '}
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Approve Business name</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      dispatch(
                                        ApprovedBussinessName({
                                          businessNameId: data?.notificationDetails?._id,
                                          status: 'ACTIVE',
                                          notificationId: data?._id,
                                          region: data?.notificationDetails?.region,
                                        })
                                      ).then(() => {
                                        setIsRefresh(!isRefresh)
                                      })
                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-check fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Reject Business name</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      dispatch(
                                        ApprovedBussinessName({
                                          businessNameId: data?.notificationDetails?._id,
                                          status: 'DENIED',
                                          notificationId: data?._id,
                                          region: data?.notificationDetails?.region,
                                        })
                                      ).then(() => {
                                        setIsRefresh(!isRefresh)
                                      })
                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-x fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                              </>
                            ) : null}

                            {data?.notificationType == 'message_verification_request' &&
                            (data?.status == 'appproved' || data?.status == 'rejected') ? (
                              <>
                                <a className={`badge badge-light-${getFontColor(data)} w-auto`}>
                                  {capitalizeFirstLetter(data?.status)}
                                </a>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>View Request</Tooltip>}
                                >
                                  <span
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                    onClick={() => {
                                      dispatch(readNotification({ids: [data?._id]}))
                                      window.open(
                                        data?.message?.split('URL:')?.[1] + '/' + data?._id
                                      )
                                    }}
                                  >
                                    <i className='bi bi-eye-fill fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                              </>
                              
                            ) : data?.notificationType === 'message_verification_request' ? (
                              <>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>View Request</Tooltip>}
                                >
                                  <span
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                    onClick={() => {
                                      dispatch(readNotification({ids: [data?._id]}))
                                      window.open(
                                        data?.message?.split('URL:')?.[1] + '/' + data?._id
                                      )
                                    }}
                                  >
                                    <i className='bi bi-eye-fill fs-5'></i>
                                  </span>
                                </OverlayTrigger>

                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Just Send</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      dispatch(
                                        FirstMessageApprovalResponse({
                                          id: data?.notificationDetails?._id,
                                          data: {
                                            status: 'approved',
                                            camp_type: data?.notificationDetails?.camp_type,
                                            notificationId: data?._id,
                                          },
                                        })
                                      ).then(() => {
                                        setIsRefresh(!isRefresh)
                                      })
                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-box-arrow-in-right'></i>
                                  </span>
                                </OverlayTrigger>

                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Reject & refund</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      dispatch(
                                        FirstMessageApprovalResponse({
                                          id: data?.notificationDetails?._id,
                                          data: {
                                            status: 'reject',
                                            camp_type: data?.notificationDetails?.camp_type,
                                            notificationId: data?._id,
                                          },
                                        })
                                      ).then(() => {
                                        setIsRefresh(!isRefresh)
                                      })
                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-x fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                              </>
                            ) : null}

                            {data?.notificationType == 'account_change_type_request' &&
                            (data?.status == 'appproved' || data?.status == 'rejected') ? (
                              <a className={`badge badge-light-${getFontColor(data)} w-auto`}>
                                {capitalizeFirstLetter(data?.status)}
                              </a>
                            ) : data?.notificationType === 'account_change_type_request' ? (
                              <>
                                {' '}
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Approve account change type request</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      updateAccountType({
                                        id: data?.notificationDetails?._id,
                                        body: {status: 'approved'},
                                      })
                                        .unwrap()
                                        .then((e) => {
                                          toast.success(e.message)
                                          setIsRefresh(!isRefresh)
                                        })

                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-check fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Reject account change type request</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      updateAccountType({
                                        id: data?.notificationDetails?._id,
                                        body: {status: 'reject'},
                                      })
                                        .unwrap()
                                        .then((e) => {
                                          toast.success(e.message)
                                          setIsRefresh(!isRefresh)
                                        })
                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-x fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                              </>
                            ) : null}

                            {data?.notificationType == 'referral_code_request' &&
                            (data?.status == 'appproved' || data?.status == 'rejected') ? (
                              <a className={`badge badge-light-${getFontColor(data)} w-auto`}>
                                {capitalizeFirstLetter(data?.status)}
                              </a>
                            ) : data?.notificationType === 'referral_code_request' ? (
                              <>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Approve referral code request</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      handleSubmitReferralCode({
                                        notificationId: data?._id,
                                        status: 'approve',
                                      }).then((res) => {
                                        if ('data' in res) {
                                          if (
                                            res.data?.error &&
                                            Object.keys(res.data?.error).length > 0
                                          ) {
                                            toast.error(res?.data?.message)
                                          } else {
                                            toast.success(res?.data?.message)
                                          }
                                        } else if ('error' in res) {
                                          const resError = res.error as any
                                          if (resError.data?.message) {
                                            toast.error(resError.data?.message || '')
                                          } else {
                                            toast.error(res?.error.toString() || '')
                                          }
                                        }
                                        setIsRefresh(!isRefresh)
                                      })

                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-check fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Reject referral code request</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      handleSubmitReferralCode({
                                        notificationId: data?._id,
                                        status: 'reject',
                                      }).then((res) => {
                                        if ('data' in res) {
                                          if (
                                            res.data?.error &&
                                            Object.keys(res.data?.error).length > 0
                                          ) {
                                            toast.error(res?.data?.message)
                                          } else {
                                            toast.success(res?.data?.message)
                                          }
                                        } else if ('error' in res) {
                                          const resError = res.error as any
                                          if (resError.data?.message) {
                                            toast.error(resError.data?.message || '')
                                          } else {
                                            toast.error(res?.error.toString() || '')
                                          }
                                        }
                                        setIsRefresh(!isRefresh)
                                      })
                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-x fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                              </>
                            ) : null}

                            {data?.notificationType == 'change_user_sales_type' &&
                            (data?.status == 'appproved' || data?.status == 'rejected') ? (
                              <a className={`badge badge-light-${getFontColor(data)} w-auto`}>
                                {capitalizeFirstLetter(data?.status)}
                              </a>
                            ) : data?.notificationType === 'change_user_sales_type' ? (
                              <>
                                {' '}
                                <OverlayTrigger
                                  placement='top'
                                  overlay={
                                    <Tooltip>Approve change sales type request ok 2</Tooltip>
                                  }
                                >
                                  <span
                                    onClick={() => {
                                      updateSalesType({
                                        notificationId: data?._id,
                                        status: 'approved',
                                      })
                                        .unwrap()
                                        .then((e) => {
                                          toast.success(e.message)
                                          setIsRefresh(!isRefresh)
                                        })

                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-check fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Reject change sales type request</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      updateSalesType({
                                        notificationId: data?._id,
                                        status: 'rejected',
                                      })
                                        .unwrap()
                                        .then((e) => {
                                          toast.success(e.message)
                                          setIsRefresh(!isRefresh)
                                        })
                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <i className='bi bi-x fs-5'></i>
                                  </span>
                                </OverlayTrigger>
                              </>
                            ) : null}
                          </div>
                        </td>
                      ) : (
                        <td className='text-center'>
                          <div className='row justify-content-center m-0 gap-2'>
                            {data?.notificationType == 'referral_access_request' &&
                            (data?.status == 'appproved' || data?.status == 'rejected') ? (
                              <a className={`badge badge-light-${getFontColor(data)} w-auto`}>
                                {capitalizeFirstLetter(data?.status)}
                              </a>
                            ) : data?.notificationType === 'referral_access_request' ? (
                              <>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Approve request access</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      handleRequestAccess({
                                        notificationId: data?._id,
                                        status: 'approve',
                                      }).then((res) => {
                                        if ('data' in res) {
                                          if (
                                            res.data?.error &&
                                            Object.keys(res.data?.error).length > 0
                                          ) {
                                            toast.error(res?.data?.message)
                                          } else {
                                            toast.success(res?.data?.message)
                                          }
                                        } else if ('error' in res) {
                                          const resError = res.error as any
                                          if (resError.data?.message) {
                                            toast.error(resError.data?.message || '')
                                          } else {
                                            toast.error(res?.error.toString() || '')
                                          }
                                        }
                                        setIsRefresh(!isRefresh)
                                      })

                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-success btn-active-color-success'
                                  >
                                    <i className='bi bi-check fs-5 text-white'></i>
                                  </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip>Reject request access</Tooltip>}
                                >
                                  <span
                                    onClick={() => {
                                      handleRequestAccess({
                                        notificationId: data?._id,
                                        status: 'reject',
                                      }).then((res) => {
                                        if ('data' in res) {
                                          if (
                                            res.data?.error &&
                                            Object.keys(res.data?.error).length > 0
                                          ) {
                                            toast.error(res?.data?.message)
                                          } else {
                                            toast.success(res?.data?.message)
                                          }
                                        } else if ('error' in res) {
                                          const resError = res.error as any
                                          if (resError.data?.message) {
                                            toast.error(resError.data?.message || '')
                                          } else {
                                            toast.error(res?.error.toString() || '')
                                          }
                                        }
                                        setIsRefresh(!isRefresh)
                                      })
                                      dispatch(readNotification({ids: [data?._id]}))
                                    }}
                                    className='btn btn-sm btn-icon btn-bg-danger btn-active-color-danger'
                                  >
                                    <i className='bi bi-x fs-5 text-white'></i>
                                  </span>
                                </OverlayTrigger>
                              </>
                            ) : (
                              '--'
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
          <div className='abcd '>
            <select
              value={page?.size}
              className='SelectSize'
              onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={allNotifications?.data?.total}>ALl</option>
            </select>
            <ReactPaginate
              previousLabel='<'
              nextLabel='>'
              pageCount={allNotifications?.data?.totalPages}
              onPageChange={(e) => setPage({...page, page: e.selected + 1})}
              containerClassName={'pagiantion'}
              previousLinkClassName={'pagination__link'}
              nextLinkClassName={'pagination__link'}
              disabledClassName={'pagination__link--disabled'}
              activeClassName={'pagination__link--active'}
            />
          </div>
        </div>
      ) : (
        <NodataYet />
      )}
    </div>
  )
}

export default ApprovalNotifications
